<template>
  <b-transition name="fade">
    <div v-if="isNativePlatform && recordingUploadStore.hasActiveUploads" class="b-upload-indicator">
      <b-tag :title="$t('recordings.upload-indicator.uploading')" type="primary" icon="upload" semibold wide />
    </div>
  </b-transition>
</template>

<script setup lang="ts">
import { ApiError } from '~/api/generated';

const { t } = useI18n();
const { success } = useCustomToasts();
const { extractApiError } = useApiUtils();
const { isNativePlatform } = usePlatform();
const recordingUploadStore = useRecordingUploadStore();

watch(
  () => recordingUploadStore.completed,
  (completed) => {
    if (!completed) return;
    success(t('recordings.notifications.recording-processed', { name: completed.sessionName }));
    recordingUploadStore.clearCompleted();
  },
  { immediate: true }
);

watch(
  () => recordingUploadStore.erroredUploads,
  (erroredUploads) => {
    erroredUploads.forEach((upload) => {
      extractApiError(
        upload.error as ApiError,
        upload.errorMessageKey ?? 'recordings.notifications.recording-processing-failed'
      );

      recordingUploadStore.clearUpload(upload.sessionId);
    });
  },
  { deep: true, immediate: true }
);
</script>

<style lang="postcss">
.b-upload-indicator {
  @apply fixed left-1/2 top-0 z-40 -translate-x-1/2 pt-[calc(var(--safe-area-inset-top)+0.5rem)];
}
</style>
